import React from "react";
import { connect } from "react-redux";
import PredictInstantDashboard from "../PredictInstant";
import CustomerDashboard from "./CustomerDashboard";
const Dashboard = ({ company }) => {
    const isPredictInstant = company.isPredictInstant;
    if (isPredictInstant) {
        return React.createElement(PredictInstantDashboard, null);
    }
    return React.createElement(CustomerDashboard, null);
};
const mapStateToProps = ({ auth: { user }, customers: { companies }, }) => ({
    company: companies.find((c) => c.id === user.customerId),
});
export default connect(mapStateToProps)(Dashboard);
